import { ApiClient } from "../../api/ApiClient";
import { enqueueItem, SyncItem, SyncItemType } from "./SyncActions";
import { getUuid } from "../../utilities/Number";
import { UPDATE_BENEFICIARY, FETCH_BENEFICIARY_ERROR } from "./Common";

export const fetchBeneficiariesErrorAction = beneficiaryError => ({
  type: FETCH_BENEFICIARY_ERROR,
  beneficiaryError
});

export const updateBeneficiaryAction = beneficiary => ({
  type: UPDATE_BENEFICIARY,
  beneficiary
});

export const fetchBeneficiaries = (onSuccess, onError) => {
  return dispatch => {
    ApiClient.getBeneficiaries(getUuid())
      .then(apiData => {
        dispatch(updateBeneficiaryAction(apiData.payload));
        onSuccess(apiData.payload);
      })
      .catch(apiError => {
        dispatch(fetchBeneficiariesErrorAction(apiError));
        onError(apiError);
      });
  };
};

export const updateBeneficiaries = beneficiary => {
  return dispatch => {
    dispatch(updateBeneficiaryAction(beneficiary));

    const request = idempotentId => ApiClient.updateBeneficiaries(idempotentId, beneficiary);
    const syncItem = new SyncItem(SyncItemType.UPDATE, "update_beneficiary", request, 0, true, apiData => {});
    dispatch(enqueueItem(syncItem));
  };
};

export const sendTestMail = type => {
  return dispatch => {
    const request = idempotentId => ApiClient.sendTestMail(idempotentId, type);
    const syncItem = new SyncItem(SyncItemType.UPDATE, "sendTestMail_" + type, request, 0, true, apiData => {});
    dispatch(enqueueItem(syncItem));
  };
};

export const sendMail = () => {
  return dispatch => {
    const request = idempotentId => ApiClient.sendMail(idempotentId);
    const syncItem = new SyncItem(SyncItemType.UPDATE, "sendMail", request, 0, true, apiData => {});
    dispatch(enqueueItem(syncItem));
  };
};
